import RefuelingRequestDialog from 'components/refueling-request-dialog/refueling-request-dialog';

export default RefuelingRequestDialog;
